import { useEffect, useState } from 'react';
import HeaderMaster from '../components/HeaderMaster';
import SideBarMaster from '../components/SideBarMaster';
import FooterNavigationMaster from '../components/FooterNavigationMaster';
import styles from './UniversidadesMaster.module.css';
import { MdSchool, MdAdd, MdEdit, MdDelete, MdSearch, MdToggleOn, MdToggleOff, MdBusiness } from "react-icons/md";
import axios from 'axios';

function UniversidadesMaster() {
    const [universidades, setUniversidades] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentUniversidade, setCurrentUniversidade] = useState({
        id: null,
        nome: '',
        sigla: '',
        cidade: '',
        estado: '',
        endereco: '',
        telefone: '',
        email: '',
        site: '',
        logo: ''
    });

    useEffect(() => {
        fetchUniversidades();
    }, []);

    const fetchUniversidades = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            const response = await axios.get(`${API_URL}/master/universidades`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            setUniversidades(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Erro ao buscar universidades:", error);
            setLoading(false);
        }
    };

    const handleOpenModal = (universidade = null) => {
        if (universidade) {
            setEditMode(true);
            setCurrentUniversidade({
                id: universidade.id_universidade,
                nome: universidade.nome,
                sigla: universidade.sigla,
                cidade: universidade.cidade,
                estado: universidade.estado,
                endereco: universidade.endereco || '',
                telefone: universidade.telefone || '',
                email: universidade.email || '',
                site: universidade.site || '',
                logo: universidade.logo || ''
            });
        } else {
            setEditMode(false);
            setCurrentUniversidade({
                id: null,
                nome: '',
                sigla: '',
                cidade: '',
                estado: '',
                endereco: '',
                telefone: '',
                email: '',
                site: '',
                logo: ''
            });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentUniversidade({
            id: null,
            nome: '',
            sigla: '',
            cidade: '',
            estado: '',
            endereco: '',
            telefone: '',
            email: '',
            site: '',
            logo: ''
        });
    };

    const handleSave = async () => {
        try {
            const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
            const token = localStorage.getItem('token');

            if (editMode) {
                await axios.put(
                    `${API_URL}/master/universidades/${currentUniversidade.id}`,
                    currentUniversidade,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );
            } else {
                await axios.post(
                    `${API_URL}/master/universidades`,
                    currentUniversidade,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );
            }

            fetchUniversidades();
            handleCloseModal();
        } catch (error) {
            console.error("Erro ao salvar universidade:", error);
            alert("Erro ao salvar universidade. Tente novamente.");
        }
    };

    const handleToggleStatus = async (id, currentStatus) => {
        const novoStatus = !currentStatus;
        const acao = novoStatus ? 'ativar' : 'desativar';
        const mensagemConfirmacao = novoStatus
            ? 'Tem certeza que deseja ativar esta universidade?'
            : 'Tem certeza que deseja desativar esta universidade? Todos os estabelecimentos associados também serão desativados.';

        if (window.confirm(mensagemConfirmacao)) {
            try {
                const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
                const token = localStorage.getItem('token');

                await axios.patch(
                    `${API_URL}/master/universidades/${id}/status`,
                    { ativa: novoStatus },
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                );

                alert(`Universidade ${novoStatus ? 'ativada' : 'desativada'} com sucesso!`);
                fetchUniversidades();
            } catch (error) {
                console.error(`Erro ao ${acao} universidade:`, error);
                console.error('Resposta completa:', error.response);

                let errorMsg = `Erro ao ${acao} universidade. Tente novamente.`;

                if (error.response?.data) {
                    errorMsg = error.response.data.error || errorMsg;

                    // Se houver detalhes adicionais, mostrar também
                    if (error.response.data.details) {
                        errorMsg += `\n\nDetalhes técnicos: ${error.response.data.details}`;
                    }
                }

                alert(errorMsg);
            }
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir esta universidade?')) {
            try {
                const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';
                const token = localStorage.getItem('token');

                await axios.delete(`${API_URL}/master/universidades/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });

                fetchUniversidades();
            } catch (error) {
                console.error("Erro ao excluir universidade:", error);
                alert("Erro ao excluir universidade. Verifique se não há estabelecimentos vinculados.");
            }
        }
    };

    const filteredUniversidades = universidades.filter(uni =>
        uni.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
        uni.sigla.toLowerCase().includes(searchTerm.toLowerCase()) ||
        uni.cidade.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className={styles.secaoPrincipal}>
            <SideBarMaster />
            <div className={styles.containerDashboard}>
                <HeaderMaster />

                <div className={styles.contentDashboard}>
                    <div className={styles.tituloSecao}>
                        <div>
                            <h2>Gestão de Universidades</h2>
                        </div>
                        <button className={styles.btnAdicionar} onClick={() => handleOpenModal()}>
                            <MdAdd /> Nova Universidade
                        </button>
                    </div>

                    <div className={styles.searchBar}>
                        <MdSearch className={styles.searchIcon} />
                        <input
                            type="text"
                            placeholder="Pesquisar por nome, sigla ou cidade..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className={styles.searchInput}
                        />
                    </div>

                    <div className={styles.tableContainer}>
                        {loading ? (
                            <p className={styles.loading}>Carregando...</p>
                        ) : (
                            <>
                                {/* Tabela para desktop */}
                                <table className={styles.table}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome</th>
                                            <th>Sigla</th>
                                            <th>Cidade</th>
                                            <th>Estado</th>
                                            <th>Estabelecimentos</th>
                                            <th>Status</th>
                                            <th>Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUniversidades.length > 0 ? (
                                            filteredUniversidades.map(uni => (
                                                <tr key={uni.id}>
                                                    <td>{uni.id_universidade}</td>
                                                    <td className={styles.nomeUniversidade}>
                                                        <MdSchool className={styles.iconTable} />
                                                        {uni.nome}
                                                    </td>
                                                    <td><span className={styles.sigla}>{uni.sigla}</span></td>
                                                    <td>{uni.cidade}</td>
                                                    <td>{uni.estado}</td>
                                                    <td>
                                                        <div className={styles.estabelecimentosCount}>
                                                            <MdBusiness className={styles.iconBusiness} />
                                                            <span>{uni.total_estabelecimentos || 0}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <button
                                                            className={uni.ativa ? styles.btnStatusActive : styles.btnStatusInactive}
                                                            onClick={() => handleToggleStatus(uni.id_universidade, uni.ativa)}
                                                            title={uni.ativa ? 'Desativar universidade' : 'Ativar universidade'}
                                                        >
                                                            {uni.ativa ? <MdToggleOn /> : <MdToggleOff />}
                                                            {uni.ativa ? 'Ativa' : 'Inativa'}
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <div className={styles.actionButtons}>
                                                            <button
                                                                className={styles.btnEdit}
                                                                onClick={() => handleOpenModal(uni)}
                                                                title="Editar"
                                                            >
                                                                <MdEdit />
                                                            </button>
                                                            <button
                                                                className={styles.btnDelete}
                                                                onClick={() => handleDelete(uni.id_universidade)}
                                                                title="Excluir"
                                                            >
                                                                <MdDelete />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="8" className={styles.noData}>
                                                    Nenhuma universidade encontrada
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Cards para mobile */}
                                <div className={styles.cardsContainer}>
                                    {filteredUniversidades.length > 0 ? (
                                        filteredUniversidades.map(uni => (
                                            <div key={uni.id} className={styles.card}>
                                                <div className={styles.cardHeader}>
                                                    <div className={styles.cardTitle}>
                                                        <MdSchool className={styles.cardIcon} />
                                                        <div>
                                                            <h3>{uni.nome}</h3>
                                                            <span className={styles.siglaCard}>{uni.sigla}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className={styles.cardBody}>
                                                    <div className={styles.cardRow}>
                                                        <strong>ID:</strong>
                                                        <span>{uni.id_universidade}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Cidade:</strong>
                                                        <span>{uni.cidade}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Estado:</strong>
                                                        <span>{uni.estado}</span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Estabelecimentos:</strong>
                                                        <span className={styles.estabelecimentosCountCard}>
                                                            <MdBusiness /> {uni.total_estabelecimentos || 0}
                                                        </span>
                                                    </div>

                                                    <div className={styles.cardRow}>
                                                        <strong>Status:</strong>
                                                        <button
                                                            className={uni.ativa ? styles.btnStatusActive : styles.btnStatusInactive}
                                                            onClick={() => handleToggleStatus(uni.id_universidade, uni.ativa)}
                                                        >
                                                            {uni.ativa ? <MdToggleOn /> : <MdToggleOff />}
                                                            {uni.ativa ? 'Ativa' : 'Inativa'}
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className={styles.cardFooter}>
                                                    <button
                                                        className={styles.btnEdit}
                                                        onClick={() => handleOpenModal(uni)}
                                                    >
                                                        <MdEdit />
                                                        <span>Editar</span>
                                                    </button>
                                                    <button
                                                        className={styles.btnDelete}
                                                        onClick={() => handleDelete(uni.id_universidade)}
                                                    >
                                                        <MdDelete />
                                                        <span>Excluir</span>
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className={styles.noData}>Nenhuma universidade encontrada</p>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <FooterNavigationMaster />

            {showModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <h3>{editMode ? 'Editar Universidade' : 'Nova Universidade'}</h3>
                        <form onSubmit={(e) => { e.preventDefault(); handleSave(); }} className={styles.formContainer}>
                            <div className={styles.formGroup}>
                                <label>Nome da Universidade</label>
                                <input
                                    type="text"
                                    value={currentUniversidade.nome}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, nome: e.target.value })}
                                    required
                                    placeholder="Ex: Universidade Federal de São Paulo"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Sigla</label>
                                <input
                                    type="text"
                                    value={currentUniversidade.sigla}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, sigla: e.target.value })}
                                    required
                                    placeholder="Ex: UNIFESP"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Cidade</label>
                                <input
                                    type="text"
                                    value={currentUniversidade.cidade}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, cidade: e.target.value })}
                                    required
                                    placeholder="Ex: São Paulo"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Estado</label>
                                <input
                                    type="text"
                                    value={currentUniversidade.estado}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, estado: e.target.value })}
                                    required
                                    placeholder="Ex: SP"
                                    maxLength="2"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Endereço</label>
                                <input
                                    type="text"
                                    value={currentUniversidade.endereco}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, endereco: e.target.value })}
                                    required
                                    placeholder="Ex: Rua da Reitoria, 374 - Cidade Universitária"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Telefone</label>
                                <input
                                    type="text"
                                    value={currentUniversidade.telefone}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, telefone: e.target.value })}
                                    placeholder="Ex: (11) 3091-3000"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Email</label>
                                <input
                                    type="email"
                                    value={currentUniversidade.email}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, email: e.target.value })}
                                    placeholder="Ex: contato@universidade.br"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Site</label>
                                <input
                                    type="url"
                                    value={currentUniversidade.site}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, site: e.target.value })}
                                    placeholder="Ex: https://www.universidade.br"
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <label>Logo (URL)</label>
                                <input
                                    type="url"
                                    value={currentUniversidade.logo}
                                    onChange={(e) => setCurrentUniversidade({ ...currentUniversidade, logo: e.target.value })}
                                    placeholder="Ex: https://example.com/logo.png"
                                />
                            </div>
                            <div className={styles.modalActions}>
                                <button type="button" className={styles.btnCancelar} onClick={handleCloseModal}>
                                    Cancelar
                                </button>
                                <button type="submit" className={styles.btnSalvar}>
                                    Salvar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default UniversidadesMaster;
